<script lang="ts" setup>
import ButtonSet from '@/components/ButtonSet.vue'
import { ValidatorType } from '@/helper/ValidateDirective'
import { HPPlacement } from '@/helper/Types'
import HelpLabel from '@/components/HelpLabel.vue'
import formStore from '@/store/FormStore'
import projectStore from '@/store/ProjectStore'
import userStore from '@/store/UserStore'
import { ModalTypes } from '@/helper/ModalTypes.ts'

const props = defineProps<{
  validator: ValidatorType
}>()

defineExpose({
  validator: props.validator
})

const hpPlacementType = HPPlacement
const iconPath = '/static/img/wall-setup.svg'
</script>

<template>
  <section ref="hpPlacement" class="form__section has--line section--hp-placement">
    <div class="form__section-inner">
      <div class="form__title">
        <h2>{{ $t('step_heating_details.title_hp_placement') }}</h2>
        <HelpLabel :modal-type="ModalTypes.PLACEMENT_INFO" />
      </div>
      <p class="form__description">
        {{ $t('step_heating_details.info_hp_placement') }}
      </p>

      <ButtonSet
        key="button-set-hp-placement"
        v-model="formStore.data.heatPumpPlacement"
        v-validate="projectStore.projectProperties.heatPumpPlacement.formValidationRule"
        :buttons="[
          {
            caption: $t('step_heating_details.hp_placement_title_' + hpPlacementType.FREE.toLowerCase()),
            info: $t('step_heating_details.hp_placement_info_' + hpPlacementType.FREE.toLowerCase()),
            value: hpPlacementType.FREE,
            iconIdentifier: `${iconPath}#heatpump-no-walls-` + userStore.themeClass
          },
          {
            caption: $t('step_heating_details.hp_placement_title_' + hpPlacementType.ONE_WALL.toLowerCase()),
            info: $t('step_heating_details.hp_placement_info_' + hpPlacementType.ONE_WALL.toLowerCase()),
            value: hpPlacementType.ONE_WALL,
            iconIdentifier: `${iconPath}#heatpump-one-wall-` + userStore.themeClass
          },
          {
            caption: $t('step_heating_details.hp_placement_title_' + hpPlacementType.TWO_WALLS.toLowerCase()),
            info: $t('step_heating_details.hp_placement_info_' + hpPlacementType.TWO_WALLS.toLowerCase()),
            value: hpPlacementType.TWO_WALLS,
            iconIdentifier: `${iconPath}#heatpump-two-walls-` + userStore.themeClass
          }
        ]"
        :error-text="validator.hpPlacement?.error.value"
        :fill-width="true"
        :is-unselectable="true"
        :large="true"
        :svg-icon="true"
        name="hp-placement"
      />
    </div>
  </section>
</template>
